<template lang="pug">
v-chip(:color="color" :text-color="textColor")
  v-avatar(v-if="icon !== null")
    v-icon(:color="iconColor" v-text="`$vuetify.icons.${icon}`")
  | {{ text }}
</template>

<script>
export default {
  name: 'Chips',
  props: {
    text: {
      type: [Number, String],
      required: true,
    },
    icon: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: "accent",
    },
    textColor: {
      type: String,
      default: "white",
    },
    iconColor: {
      type: String,
      default: null,
    },
  },
}
</script>
